import type {
  AiSpreadsheetOverrideOutcome,
  AiSpreadsheetValueType,
} from "./cell";

export const AI_SPREADSHEET_REGION_OVERRIDE_REVIEW_REASON = {
  ambiguous: "ambiguous",
  conflict: "conflict",
} as const;

export type AiSpreadsheetRegionOverrideReviewReason =
  (typeof AI_SPREADSHEET_REGION_OVERRIDE_REVIEW_REASON)[keyof typeof AI_SPREADSHEET_REGION_OVERRIDE_REVIEW_REASON];

export interface IAiSpreadsheetRegionOverrideCandidate {
  header_row: number;
  start_col: number;
  end_col: number;
}

export interface IAiSpreadsheetRegionOverrideReview {
  id: string;
  sheet_name: string;
  recipient_external_id: string | null;
  outcome: AiSpreadsheetOverrideOutcome;
  review_reason: AiSpreadsheetRegionOverrideReviewReason | null;
  header_values: string[];
  configuration: IAiSpreadsheetRegionInput;
  candidates: IAiSpreadsheetRegionOverrideCandidate[];
  replaces_generated_region: boolean;
  deletes_generated_region: boolean;
  edited_by: { id: string; full_name: string | null } | null;
}

export interface IAiSpreadsheetRegionOverrideConfirmResponse {
  region: IAiSpreadsheetRegion | null;
  override: { id: string; outcome: AiSpreadsheetOverrideOutcome };
}

export interface IAiSpreadsheetMergedRange {
  start_row: number;
  end_row: number;
  start_col: number;
  end_col: number;
}

export interface IAiSpreadsheetRegionColumnSetting {
  filterable: boolean;
  sortable: boolean;
  declared_type: AiSpreadsheetValueType | null;
}

export interface IAiSpreadsheetRegionValidation {
  valid: boolean;
  errors: string[];
}

export interface IAiSpreadsheetRegionInput {
  header_row: number;
  record_start_row: number;
  record_end_row: number;
  start_col: number;
  end_col: number;
  column_settings: Record<string, IAiSpreadsheetRegionColumnSetting>;
}

export interface IAiSpreadsheetRegion extends IAiSpreadsheetRegionInput {
  id: string;
  ai_spreadsheet_sheet_id: string;
  origin: "script" | "user_confirmed";
  created_at: string;
  updated_at: string;
  validation: IAiSpreadsheetRegionValidation;
}

export interface IAiSpreadsheetRegionResponse {
  region: IAiSpreadsheetRegion;
}
